import { useState } from 'react'

export const useSessionState = () => {
  // Core session state
  const [sessionStarted, setSessionStarted] = useState(false)
  const [showRejoin, setShowRejoin] = useState(false)
  const [tokenLoading, setTokenLoading] = useState(false)
  const [userRole, setUserRole] = useState()

  // Event and profile data
  const [profileDataLoading, setProfileDataLoading] = useState(false)
  const [bookedEventFinalData, setBookedEventFinalData] = useState()
  const [clinicLocationId, setClinicLocationId] = useState()
  const [clinicBrandId, setClinicBrandId] = useState()
  const [bookedEventDataLoading, setBookedEventDataLoading] = useState(false)
  const [mentorEventsList, setMentorEventsList] = useState()
  const [auxiliaryData, setAuxiliaryData] = useState()
  const [supportQrCodeMediaId, setSupportQrCodeMediaId] = useState()

  // Menu and UI state
  const [menuItemsList, setMenuItemsList] = useState([])
  const [selectedMenuItem, setSelectedMenuItem] = useState()
  const [drawerForMoreOptionsOpenMobile, setDrawerForMoreOptionsOpenMobile] = useState(false)
  const [anchorElForHeaderMenu, setAnchorElForHeaderMenu] = useState(null)
  const [isLayoutPinned, setIsLayoutPinned] = useState(true)

  // Prescription and reports
  const [prescriptionContentValue, setPrescriptionContentValue] = useState()
  const [hidePreviewButton, setHidePreviewButton] = useState(false)
  const [moveToPrintPrescriptionScreen, setMoveToPrintPrescriptionScreen] = useState(false)
  const [triggerSave, setTriggerSave] = useState()
  const [newWantedMenuItemId, setNewWantedMenuItemId] = useState()

  // Modal and popup states
  const [showGetPlanModal, setShowGetPlanModal] = useState(false)
  const [activityPlanNotificationData, setActivityPlanNotificationData] = useState()
  const [prewallPaywallProps, setPrewallPaywallProps] = useState({
    open: false,
    planData: '',
  })
  const [planDetailsModal, setShowPlanDetailsModal] = useState({
    open: false,
    data: null,
  })
  const [wrongAccountPopupData, setWrongAccountPopupData] = useState(null)
  const [invalidParticipantError, setInvalidParticipantError] = useState(null)

  // Loading states
  const [loadingSlots, setLoadingSlots] = useState(false)

  // Time tracking
  const [timeElapsedInSeconds, setTimeElapsedInSeconds] = useState(0)

  // Video call state
  const [joinAgoraCall, setJoinAgoraCall] = useState(false)
  const [isCameraOpen, setIsCameraOpen] = useState(false)
  const [isAudioOpen, setIsAudioOpen] = useState(false)

  // Content drawer state (for mobile)
  const [setOpenContentDrawer, setSetOpenContentDrawer] = useState(null)

  return {
    // Core session
    sessionStarted,
    setSessionStarted,
    showRejoin,
    setShowRejoin,
    tokenLoading,
    setTokenLoading,
    userRole,
    setUserRole,

    // Event and profile data
    profileDataLoading,
    setProfileDataLoading,
    bookedEventFinalData,
    setBookedEventFinalData,
    clinicLocationId,
    setClinicLocationId,
    clinicBrandId,
    setClinicBrandId,
    bookedEventDataLoading,
    setBookedEventDataLoading,
    mentorEventsList,
    setMentorEventsList,
    auxiliaryData,
    setAuxiliaryData,
    supportQrCodeMediaId,
    setSupportQrCodeMediaId,

    // Menu and UI
    menuItemsList,
    setMenuItemsList,
    selectedMenuItem,
    setSelectedMenuItem,
    drawerForMoreOptionsOpenMobile,
    setDrawerForMoreOptionsOpenMobile,
    anchorElForHeaderMenu,
    setAnchorElForHeaderMenu,
    isLayoutPinned,
    setIsLayoutPinned,

    // Prescription and reports
    prescriptionContentValue,
    setPrescriptionContentValue,
    hidePreviewButton,
    setHidePreviewButton,
    moveToPrintPrescriptionScreen,
    setMoveToPrintPrescriptionScreen,
    triggerSave,
    setTriggerSave,
    newWantedMenuItemId,
    setNewWantedMenuItemId,

    // Modals and popups
    showGetPlanModal,
    setShowGetPlanModal,
    activityPlanNotificationData,
    setActivityPlanNotificationData,
    prewallPaywallProps,
    setPrewallPaywallProps,
    planDetailsModal,
    setShowPlanDetailsModal,
    wrongAccountPopupData,
    setWrongAccountPopupData,
    invalidParticipantError,
    setInvalidParticipantError,

    // Loading states
    loadingSlots,
    setLoadingSlots,

    // Time tracking
    timeElapsedInSeconds,
    setTimeElapsedInSeconds,

    // Video call
    joinAgoraCall,
    setJoinAgoraCall,
    isCameraOpen,
    setIsCameraOpen,
    isAudioOpen,
    setIsAudioOpen,

    // Content drawer
    setOpenContentDrawer,
    setSetOpenContentDrawer,
  }
}
